// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.storage_BucketSizeChartCard_card__60MkJ {
  overflow: hidden;
}

.storage_BucketSizeChartCard_card__60MkJ h5 {
  padding: 16px 0 16px 16px;
}

.storage_BucketSizeChartCard_titleContainer__xhIO7 {
  display: flex;
  align-items: center;
  gap: 8px;
}

.storage_BucketSizeChartCard_tooltipIcon__A7-K4 {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.storage_BucketSizeChartCard_headerControls__Hv\\+sU {
  margin-right: 16px;
}

.storage_BucketSizeChartCard_content__9j8R7 {
  position: relative;
  padding: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/containers/BucketSizeChartCard/BucketSizeChartCard.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf","sourcesContent":[".card {\n  overflow: hidden;\n}\n\n.card h5 {\n  padding: 16px 0 16px 16px;\n}\n\n.titleContainer {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.tooltipIcon {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n}\n\n.headerControls {\n  margin-right: 16px;\n}\n\n.content {\n  position: relative;\n  padding: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `storage_BucketSizeChartCard_card__60MkJ`,
	"titleContainer": `storage_BucketSizeChartCard_titleContainer__xhIO7`,
	"tooltipIcon": `storage_BucketSizeChartCard_tooltipIcon__A7-K4`,
	"headerControls": `storage_BucketSizeChartCard_headerControls__Hv+sU`,
	"content": `storage_BucketSizeChartCard_content__9j8R7`
};
export default ___CSS_LOADER_EXPORT___;
